import orderflowHelper from '@/config/order'
import { sampleType } from 'json/goods-order-options'
import { labOrderSaleFrom } from 'json/lab-order'
let statusOptions = [
  {
    label: '样本接收',
    value: 'LAB_SAMPLES_RECEIVED'
  }, {
    label: '核酸提取',
    value: 'LAB_DNA_READY'
  }, {
    label: '报告生成',
    value: 'REPORT_CREATED'
  }, {
    label: '报告审核',
    value: 'REPORT_CHECKED_1ST'
  }, {
    label: '已完成',
    value: 'COMPLETED'
  }
]
export let filterFactor = [ {
  label: '待操作状态',
  type: 'select',
  clearable: true,
  value: 'targetStatus', // 需返回数据的字段名
  options: getLabStatusOptions()
}, {
  label: '订单操作时间',
  type: 'time-slot',
  value: 'operationTime',
  startName: 'opStartTime',
  endName: 'opEndTime' // 需返回数据的字段名
}, {
  label: '已操作状态',
  type: 'select',
  clearable: true,
  value: 'completeStatus', // 需返回数据的字段名
  // options: getLabStatusOptions()
  // 暂时只支持样本接收以及核酸提取的操作时间筛选，将来扩充其他状态
  options: statusOptions
}, {
  label: '检测套餐',
  type: 'select',
  clearable: true,
  value: 'detectionPackageIds', // 需返回数据的字段名
  multiple: true,
  options: []
}, {
  label: '样本类型',
  type: 'select',
  clearable: true,
  value: 'sampleTypes', // 需返回数据的字段名
  options: sampleType
},
{
  label: '地区',
  type: 'select',
  clearable: true,
  filterable: true,
  value: 'businessOriginArea', // 需返回数据的字段名
  options: []
}, {
  label: '检测平台',
  type: 'select',
  clearable: true,
  value: 'sequencingTechnologyTypes', // 需返回数据的字段名
  options: []
}, {
  label: '订单来源',
  type: 'select',
  clearable: true,
  value: 'salesFroms', // 需返回数据的字段名
  options: labOrderSaleFrom
},
{
  label: '订单类型',
  value: 'workflow',
  type: 'select',
  clearable: true,
  options: [
    {
      label: '购买订单',
      value: 'NULL'
    },
    {
      label: '解锁订单',
      value: 'REPORT_ONLY_UNLOCK'
    }
  ]
}
]

function getLabStatusOptions () {
  let options = []
  let notInclude = ['LAB_SAMPLE_RETURNED', 'CREATED', 'COMPLETED']
  orderflowHelper.getDefaultOrderFlow().forEach(item => {
    let signalItem = {
      label: item.operation,
      value: item.name
    }
    if (!notInclude.includes(signalItem.value)) {
      options.push(signalItem)
    }
  })
  return options
}
